import StepTwo from "@/components/dashboard/pay/StepTwo";

const PayStep2 = () => <StepTwo />;

export default PayStep2;
